import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../../components/Layout.js";
import axios from "axios";
import { FaWhatsapp } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { apiFetch } from "../../api.js";

const BookingDocketGrid = () => {
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [gridData, setGridData] = useState([]);
  const totalPages = Math.ceil(gridData.length / pageSize);
  const startIndex = (currentPage - 1) * pageSize;
  const paginatedData = gridData.slice(startIndex, startIndex + pageSize);
  const [showCancelPopup, setShowCancelPopup] = useState(false);
  const [selectedName, setSelectedName] = useState("");
  const [remark, setRemark] = useState("");
  const [selectedUnqid, setSelectedUnqid] = useState("");

  const styles = {
    pageContainer: {
      width: "100%",
      minHeight: "100vh",
      background: "#f4f6f8",
      padding: "10px",
    },

    container: {
      background: "#fff",
      padding: "15px",
      borderRadius: "6px",
      boxShadow: "0 2px 6px rgba(0,0,0,.1)",
    },

    header: {
      display: "flex",
      justifyContent: "space-between",
      marginBottom: 10,
      gap: 8,
    },

    leftHeader: {
      display: "flex",
      gap: 8,
      flexWrap: "wrap",
      flex: 1,
    },

    title: { fontWeight: "bold", fontSize: 18 },

    searchInput: {
      minWidth: "60%",
      padding: 8,
      border: "1px solid #ccc",
      borderRadius: 4,
    },

    searchButton: {
      background: "#2196F3",
      color: "#fff",
      border: "none",
      padding: "8px 14px",
      borderRadius: 4,
      cursor: "pointer",
    },

    select: { padding: 8, borderRadius: 4 },

    addButton: {
      background: "#3a28a0",
      color: "#fff",
      border: "none",
      padding: "8px 16px",
      borderRadius: 4,
      cursor: "pointer",
    },

    tableWrapper: { overflowX: "auto" },

    table: {
      width: "100%",
      minWidth: 1450,
      borderCollapse: "collapse",
    },

    th: {
      background: "#8B1E3F",
      color: "#fff",
      padding: 10,
      border: "1px solid #ddd",
      fontSize: 13,
    },

    td: {
      padding: 8,
      border: "1px solid #ddd",
      fontSize: 13,
      textAlign: "center",
    },

    actionSelect: {
      padding: "6px 10px",
      borderRadius: 4,
      background: "#5f6368",
      color: "#fff",
      border: "1px solid #444",
      cursor: "pointer",
      fontSize: 12,
    },

    iconBtn: (bg) => ({
      width: 36,
      height: 36,
      borderRadius: "50%",
      background: bg,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      border: "none",
      cursor: "pointer",
      boxShadow: "0 2px 5px rgba(0,0,0,.2)",
    }),

    cancelBtn: {
      background: "#d32f2f",
      color: "#fff",
      border: "none",
      padding: "6px 12px",
      borderRadius: 4,
      cursor: "pointer",
      fontSize: 12,
    },

    pagination: {
      marginTop: 12,
      display: "flex",
      justifyContent: "center",
      gap: 10,
    },

    pageBtn: {
      padding: "6px 12px",
      border: "1px solid #ccc",
      borderRadius: 4,
      cursor: "pointer",
    },
  };
  // ✅ BOOKING DOCKET GRID WORKING
  useEffect(() => {
    fetchGrid();
  }, []);
  const fetchGrid = async () => {
    try {
      const res = await apiFetch("/api/booking/grid", {
        method: "POST",
      });
      const data = await res.json();
      if (data.err === "0") setGridData(data.list || []);
    } catch {
      setGridData([]);
    }
  };
  // ✅ BOOKING DOCKET SEARCH BUTTON WORKING
  const handleSearch = async () => {
    try {
      const res = await apiFetch("/api/booking/search", {
        method: "POST",
        body: JSON.stringify({ search: searchText }),
      });
      const data = await res.json();
      console.log(data);
      if (data.err === "0") {
        setGridData(data.list || []);
        setCurrentPage(1);
      } else {
        setGridData([]);
      }
    } catch (err) {
      console.error("Search Error:", err);
      setGridData([]);
    }
  };
  // ✅ BOOKING DOCKET PRINT AND PRINT CC BUTTON WORKING
  const handlePrint = async (unqid, type = "normal") => {
    console.log("API CALL STARTED:", { unqid, type });

    try {
      const res = await apiFetch(
        "/api/booking/print-pdf",
        {
          method: "POST",
          body: JSON.stringify({ unqid, type }),
        },
      );

      // ✅ CHECK RESPONSE
      if (!res.ok) {
        alert("❌ Print failed (server error)");
        return;
      }

      // ✅ GET PDF DIRECTLY (NO .json())
      const blob = await res.blob();

      // ✅ VALIDATE
      if (!blob || blob.size === 0) {
        alert("❌ Empty PDF received");
        return;
      }

      if (blob.type !== "application/pdf") {
        console.error("Invalid type:", blob.type);
        alert("❌ Invalid PDF file");
        return;
      }

      // ✅ OPEN PDF
      const url = window.URL.createObjectURL(blob);
      window.open(url, "_blank");

      // ✅ CLEAN MEMORY
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
      }, 5000);
    } catch (err) {
      console.error("PRINT ERROR:", err);
      alert("❌ Error printing");
    }
  };
  // ✅ BOOKING DOCKET WHATSUP BUTTON WORKING
  const handleWhatsApp = async (unqid) => {
    try {
      const res = await apiFetch(
        "/api/booking/send-whatsapp",
        { method: "POST", body: JSON.stringify({ unqid }) },
      );
      const data = await res.json();
      if (data.err === "0") {
        alert("WhatsApp Message Sent Successfully");
      } else {
        alert(data.msg);
      }
    } catch (err) {
      console.error(err);
      alert("Error sending WhatsApp");
    }
  };

  // ✅ BOOKING DOCKET MAIL BUTTON (NEW)
  const handleMail = async (unqid) => {
    try {
      const res = await apiFetch(
        "/api/booking/send-mail",
        { method: "POST", body: JSON.stringify({ unqid }) },
      );
      const data = await res.json();
      if (data.err === "0") {
        alert("Email Sent Successfully");
      } else {
        alert(data.msg);
      }
    } catch (err) {
      console.error(err);
      alert("Error sending Email");
    }
  };
  return (
    <Layout>
      <div style={styles.pageContainer}>
        <div style={styles.container}>
          {/* HEADER */}
          <div style={styles.header}>
            <div style={styles.leftHeader}>
              <div style={styles.title}>DOCKET GRID</div>
              <input
                placeholder="Search..."
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                style={styles.searchInput}
              />

              <button style={styles.searchButton} onClick={handleSearch}>
                Search
              </button>

              <select
                value={pageSize}
                onChange={(e) => {
                  setPageSize(+e.target.value);
                  setCurrentPage(1);
                }}
                style={styles.select}
              >
                {[10, 20, 50, 100].map((s) => (
                  <option key={s}>{s} / page</option>
                ))}
              </select>
            </div>

            <button
              style={styles.addButton}
              onClick={() => navigate("/BookingDocket")}
            >
              Add New
            </button>
          </div>

          {/* TABLE */}
          <div style={styles.tableWrapper}>
            <table style={styles.table}>
              <thead>
                <tr>
                  {[
                    "Date",
                    "Docket No",
                    "Name",
                    "Model",
                    "Variant",
                    "Package Price",
                    "Status",
                    "Action",
                  ].map((h) => (
                    <th key={h} style={styles.th}>
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {paginatedData.map((row, i) => (
                  <tr key={i}>
                    <td style={styles.td}>{row.sp_737}</td>
                    <td style={styles.td}>{row.sp_738}</td>
                    <td style={styles.td}>{row.sp_740}</td>
                    <td style={styles.td}>{row.sp_749}</td>
                    <td style={styles.td}>{row.sp_750}</td>
                    <td style={styles.td}>{row.sp_752}</td>
                    <td style={styles.td}>{row.status}</td>

                    <td style={styles.td}>
                      <select
                        style={styles.actionSelect}
                        onChange={(e) => {
                          const v = e.target.value;
                          if (v === "edit")
                            navigate("/BookingDocket", {
                              state: { unqid: row.sp_732 },
                            });
                          if (v === "view")
                            navigate("/BookingDocket", {
                              state: { viewUnqid: row.sp_732 },
                            });
                          if (v === "print") {
                            console.log("Row Status:", row.status);

                            if (
                              (row.status || "").toLowerCase() !== "approve"
                            ) {
                              alert("Booking Is Not Approve");
                              return;
                            }

                            console.log("PRINT CLICKED");

                            handlePrint(row.sp_732);
                          }
                          if (v === "printcc") {
                            handlePrint(row.sp_732, "cc");
                          }

                          if (v === "whatsapp") {
                            handleWhatsApp(row.sp_732);
                          }

                          if (v === "mail") {
                            handleMail(row.sp_732);
                          }

                          if (v === "cancel") {
                            const status = (row.status || "").toLowerCase();

                            // SAME AS ASP.NET LOGIC
                            if (status === "cancelled") {
                              alert("Booking Already Cancelled.");
                              return;
                            }

                            // Set data in popup
                            setSelectedName(row.sp_740);
                            setSelectedUnqid(row.sp_732);
                            setRemark("");

                            // Open modal
                            setShowCancelPopup(true);
                          }
                          e.target.value = "";
                        }}
                      >
                        <option value="">-- Select --</option>
                        <option value="edit">Edit</option>
                        <option value="view">View</option>
                        <option value="print">Print</option>
                        <option value="printcc">Print CC</option>
                        <option value="whatsapp">WhatsApp</option>
                        <option value="mail">Mail</option>
                        <option value="cancel">Cancel</option>
                      </select>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* PAGINATION */}
          <div style={styles.pagination}>
            <button
              style={styles.pageBtn}
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => p - 1)}
            >
              Prev
            </button>
            Page {currentPage} of {totalPages || 1}
            <button
              style={styles.pageBtn}
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage((p) => p + 1)}
            >
              Next
            </button>
          </div>
        </div>
        {showCancelPopup && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0,0,0,0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
          >
            <div
              style={{
                width: "600px",
                background: "#fff",
                borderRadius: "6px",
                overflow: "hidden",
              }}
            >
              {/* HEADER */}
              <div
                style={{
                  background: "#8B1E3F",
                  color: "#fff",
                  padding: "12px 16px",
                  fontWeight: "bold",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                Booking Cancel
                <span
                  style={{ cursor: "pointer", fontSize: "18px" }}
                  onClick={() => setShowCancelPopup(false)}
                >
                  ×
                </span>
              </div>

              {/* BODY */}
              <div style={{ padding: "20px" }}>
                {/* CUSTOMER NAME */}
                <div style={{ marginBottom: "15px" }}>
                  <label style={{ fontWeight: "bold" }}>Customer Name</label>
                  <input
                    type="text"
                    value={selectedName}
                    readOnly
                    style={{
                      width: "100%",
                      padding: "8px",
                      marginTop: "5px",
                      border: "1px solid #ccc",
                    }}
                  />
                </div>

                {/* REMARK */}
                <div style={{ marginBottom: "15px" }}>
                  <label style={{ fontWeight: "bold" }}>Remark</label>
                  <input
                    type="text"
                    placeholder="ENTER REMARK"
                    value={remark}
                    onChange={(e) => setRemark(e.target.value)}
                    style={{
                      width: "100%",
                      padding: "8px",
                      marginTop: "5px",
                      border: "1px solid #ccc",
                    }}
                  />
                </div>

                {/* BUTTONS */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "10px",
                  }}
                >
                  <button
                    style={{
                      background: "#1976d2",
                      color: "#fff",
                      padding: "8px 20px",
                      border: "none",
                      borderRadius: "4px",
                    }}
                    onClick={async () => {
                      if (!remark) {
                        alert("Please enter remark");
                        return;
                      }

                      try {
                        const res = await axios.post(
                          "/api/booking/reject",
                          {
                            sp_732: selectedUnqid,
                            sp_733: "ADMIN",
                            sp_734: "SYSTEM",
                            sp_892: remark,
                          },
                        );

                        if (res.data.err === "0") {
                          alert(res.data.msg);
                          setShowCancelPopup(false);
                          navigate("/BookingDocketGrid");
                        } else {
                          alert(res.data.msg);
                        }
                      } catch (err) {
                        console.error(err);
                        alert("Error cancelling booking");
                      }
                    }}
                  >
                    Save
                  </button>

                  <button
                    style={{
                      background: "#e53935",
                      color: "#fff",
                      padding: "8px 20px",
                      border: "none",
                      borderRadius: "4px",
                    }}
                    onClick={() => setShowCancelPopup(false)}
                  >
                    Exit
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default BookingDocketGrid;
